import { useLocation } from "react-router-dom"

import {
  buildCandidateDetailsNavigationState,
  buildCandidatesListContext,
} from "./navigation"

export function useCandidatesListNavigationState({
  debouncedFilters,
  debouncedTableSearchQuery,
  serverSort,
  pageIndex,
  pageSize,
  tableRows,
  totalResultsSize,
}) {
  const location = useLocation()

  function buildListNavigationStateForRow(rowData) {
    const rowIndex = tableRows.findIndex(
      (row) => Number(row.id) === Number(rowData.id)
    )
    if (rowIndex < 0) {
      return null
    }

    return buildCandidateDetailsNavigationState(
      location.search,
      buildCandidatesListContext({
        filters: debouncedFilters,
        q: debouncedTableSearchQuery,
        ordering: serverSort,
        pageIndex,
        pageSize,
        rowIndex,
        pageCandidateIds: tableRows.map((row) => Number(row.id)),
        totalCount: totalResultsSize,
      })
    )
  }

  return { buildListNavigationStateForRow }
}
